import { api } from '@marketplace-web/core-api/core-api-client-util'

import {
  UpdateBusinessAccountBankDetailsArgs,
  WalletConversionErrorDto,
  WalletConversionStatusResp,
} from '../types/wallet-conversion'

export const convertBusinessWallet = () =>
  api.post<WalletConversionStatusResp, WalletConversionErrorDto>('/business_accounts/conversion')

export const getWalletConversionStatus = () =>
  api.get<WalletConversionStatusResp>('/business_accounts/conversion')

export const updateBusinessAccountBankDetails = ({
  bankAccountOwnerName,
  bankAccountNumber,
}: UpdateBusinessAccountBankDetailsArgs) =>
  api.put('/business_accounts_dsa', {
    bank_account_number: bankAccountNumber,
    bank_account_owner_name: bankAccountOwnerName,
  })
